import Parse from "parse";

export const getPersonByUser = async (user: any): Promise<any | undefined> => {
    const person = new Parse.Query("Person").limit(10000);
    const personQuery = person.equalTo("parseUser", user);
    return await personQuery.first();
}